import { gaEvents } from '../../../../modules/analytics/google/dispatchGoogleAnalyticsEvent';
import { FilterAddCommand, FilterRemoveCommand } from '../../../../modules/sortAndFilter/patterns/commands/googleAnalytics';
import { FilterTypes } from '../../../../modules/sortAndFilter/workers/sortAndFilter';
import { FilterHeadings } from '../TreatmentFilter/Filters/FilterUi/FilterSection/FilterSection';

class FilterSet<T> extends Set<T> {
    type = '' as FilterTypes['type'];

    constructor(type: FilterTypes['type']) {
        super();
        this.type = type;
    }

    add = (value: T) => {
        new FilterAddCommand().execute({
            event: gaEvents.FilterAdd,
            filterMenu: FilterHeadings[this.type],
            filterSelection: JSON.stringify(value).replace(/^"(.*)"$/, '$1'),
            list: window.location.pathname,
        });

        return super.add(value);
    };

    delete = (value: T) => {
        new FilterRemoveCommand().execute({
            event: gaEvents.FilterRemove,
            filterMenu: FilterHeadings[this.type],
            filterSelection: JSON.stringify(value).replace(/^"(.*)"$/, '$1'),
            list: window.location.pathname,
        });

        return super.delete(value);
    };
}

export default FilterSet;
